import React from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { ActivityTable } from "./activity-table/ActivityTable";

export default function Actiivity() {
 
  return (
    <Card>
          <CardHeader title='Activities'>
            <CardHeaderToolbar>
             
            </CardHeaderToolbar>
          </CardHeader>{" "}
      <CardBody>
        <ActivityTable />
      </CardBody>
    </Card>
  );
}
